const DEFAULT_CLEARSPACE = '0';
const UI_BAR_CLEARSPACE = '30px';

import WatermarkStatus from '../../../../../State/Stores/Frame/Constants/WatermarkStatus';
import styles          from '../Constants/styles';

const createWatermarkStyles = (
    corner: WatermarkStatus,
    areControlsActive: boolean
): React.CSSProperties => {
    const customStyles = Object.assign({}, styles);

    switch (corner) {
        case WatermarkStatus.TOP_LEFT:
            customStyles.left = DEFAULT_CLEARSPACE;
            customStyles.top = DEFAULT_CLEARSPACE;

            break;
        case WatermarkStatus.TOP_RIGHT:
            customStyles.right = DEFAULT_CLEARSPACE;
            customStyles.top = DEFAULT_CLEARSPACE;

            break;
        case WatermarkStatus.BOTTOM_LEFT:
            customStyles.left = DEFAULT_CLEARSPACE;
            customStyles.bottom = areControlsActive ? UI_BAR_CLEARSPACE : DEFAULT_CLEARSPACE;

            break;
        case WatermarkStatus.BOTTOM_RIGHT:
            customStyles.right = DEFAULT_CLEARSPACE;
            customStyles.bottom = areControlsActive ? UI_BAR_CLEARSPACE : DEFAULT_CLEARSPACE;

            break;
    }

    return customStyles;
};

export default createWatermarkStyles;